<ng-container>
  <mat-card class="mat-elevation-z5">
    <mat-card-content>
      <div class="mt-13 mb-13">
        <button
          type="button"
          class="btn btn-primary mr-2"
          (click)="exportReport()"
          [disabled]="loadClicksMetrics || clicksData.length === 0"
          [ngClass]="{ 'kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light': loadExportClicksMetrics }"
        >
          {{ 'MONITORING_CLICK.EXPORT_BUTTON' | transloco }}
        </button>
      </div>
      <kt-range-datepicker
        (max)="setMaxDate($event)"
        (min)="setMinDate($event)"
        defaultMinDate="{{ minDate }}"
        defaultMaxDate="{{ maxDate }}"
      ></kt-range-datepicker>
      <div *ngIf="!loadClicksMetrics">
        <div *ngIf="clicksData.length === 0" class="p-5 text-center">
          <h4>{{ 'MONITORING_CLICK.NOT_FOUND' | transloco }}</h4>
        </div>
        <div *ngIf="clicksData.length !== 0">
          <div class="table-scrollable">
            <table class="table table-striped table-bordered">
              <thead>
                <tr>
                  <th scope="col">{{ 'MONITORING_CLICK.PAGE' | transloco }}</th>
                  <th scope="col">{{ 'MONITORING_CLICK.USER_NAME' | transloco }}</th>
                  <th scope="col">{{ 'MONITORING_CLICK.LAST_ACTIVITY' | transloco }}</th>
                  <th scope="col">{{ 'MONITORING_CLICK.PAGE_CLICKS' | transloco }}</th>
                  <th scope="col">{{ 'MONITORING_CLICK.IFRAME_CLICKS' | transloco }}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of data">
                  <td>{{ getTitle(item) }}</td>
                  <td class="text-center">{{ item.userName }}</td>
                  <td class="text-center">{{ item.updatedAt | date: 'd.MM.yy H.mm.ss' }}</td>
                  <td class="text-center">{{ item.countClicks }}</td>
                  <td class="text-center">{{ item.countClicksDashboard }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <mat-paginator
            [length]="clicksData.length"
            [pageSize]="getDefaultPageSize()"
            [pageSizeOptions]="pageSizeOptions"
            (page)="pageEvent($event)"
          >
          </mat-paginator>
        </div>
      </div>
      <div *ngIf="loadClicksMetrics" class="d-flex justify-content-center align-items-center p-5">
        <mat-spinner [diameter]="35"></mat-spinner>
      </div>
    </mat-card-content>
  </mat-card>
</ng-container>
